import { useSearchParams } from "react-router-dom";

const QueryChecker = (list) => {
  const [searchParams] = useSearchParams();
  let queryString = "";
  if (list && list.length > 0) {
    list.map((v) => {
      let ask = searchParams.get(v);
      if (ask) {
        if (queryString.length > 0) {
          queryString = queryString + `&${v}=${ask}`;
        } else {
          queryString = `?${v}=${ask}`;
        }
      }
    });
  }

  // console.log(queryString)

  return queryString;
};

export default QueryChecker;
